import React, { useEffect, useRef } from "react";
import "./HomeAbout.css";
import whatwedo from "../../Asset/tour2.jpeg";
import making from "../../Asset/tour1.jpeg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
const HomeAbout = () => {
  gsap.registerPlugin(ScrollTrigger);

  var scrollData = "";
  function getScrollData() {
    console.log(scrollData);
    if (window.innerWidth >= 1200) {
      scrollData = "top 10%";
    } else if (window.innerWidth >= 600) {
      scrollData = "top 22%";
    } else {
      scrollData = "top 0%";
    }
  }
  useEffect(() => {
    getScrollData();
  }, [window.innerWidth]);

  const triggerRef = useRef(null);
  const sectionRef = useRef(null);
  useEffect(() => {
    // gsap.from(".whatwedoimg", {
    //   ease: "elastic.out(1, 1.3)",
    //   marginLeft: "-500px",
    //   opacity: 0,
    //   scrollTrigger: {
    //     trigger: ".wrapper1",
    //     scrub: 1,
    //   },
    // });
    // gsap.from(".making", {
    //   ease: "elastic.out(1, 1.3)",
    //   marginLeft: "-500px",
    //   opacity: 0,
    //   scrollTrigger: {
    //     trigger: ".wrapper1",
    //     scrub: 1,
    //   },
    // });
    var sections = [1, 2, 3];

    const pin = gsap.fromTo(
      sectionRef.current,
      {
        translateY: 0,
      },
      {
        yPercent: -40 * (sections.length - 1),

        ease: "none",
        scrollTrigger: {
          trigger: triggerRef.current,
          // start: "top 10%", web
          // start: "top 22%",tab
          start: scrollData,
          scrub: 3,
          pin: true,
        },
      }
    );

    return () => {
      pin.kill();
    };
  }, []);
  return (
    <div>
      <div ref={triggerRef} className="wrapper1 webAbout">
        <div ref={sectionRef} className="ourProductsContainer1">
          <div className="productContainer1">
            <div className="mobViewdiv"></div>
            <div className="Advantages">
              <h1> Healthier Ingredients</h1>
              <p>
                When you prepare your own meals, you have control over the
                ingredients you use. You can choose fresh, high-quality
                ingredients and avoid additives, preservatives, and unhealthy
                additives that are often found in processed foods and restaurant
                meals. This gives you the ability to make healthier choices,
                control portion sizes, and cater to specific dietary needs.
              </p>
            </div>
          </div>
          <div className="productContainer1">
            <div className="mobViewdiv"></div>
            <div className="Advantages">
              <h1>Portion Control</h1>
              <p>
                One of the challenges with eating out is the tendency for larger
                portion sizes, which can contribute to overeating. Cooking at
                home allows you to control portion sizes and be mindful of your
                calorie intake. This can be particularly beneficial for weight
                management and maintaining a balanced diet.
              </p>
            </div>
          </div>
          <div className="productContainer1">
            <div className="mobViewdiv"></div>
            <div className="Advantages">
              <h1> Creativity and Variety</h1>
              <p>
                Cooking at home allows you to explore a wide range of recipes,
                experiment with flavors, and get creative in the kitchen. You
                have the freedom to try new ingredients, cooking techniques, and
                cultural cuisines, which can make mealtime more exciting and
                enjoyable.
              </p>
            </div>
          </div>
        </div>
        <div className="whatwedo">
          <img className="whatwedoimg" src={whatwedo} alt="whatwedo" />
          <img className="making" src={making} alt="whatwedo" />
        </div>
      </div>
      <div className="wrapperMob mobAbout">
        <img className="whatwedoimg" src={whatwedo} alt="whatwedo" />
        <div className="ourProductsContainer1">
          <div className="productContainer1">
            <div className="mobViewdiv"></div>
            <div className="Advantages">
              <h1> Healthier Ingredients</h1>
              <p>
                When you prepare your own meals, you have control over the
                ingredients you use. You can choose fresh, high-quality
                ingredients and avoid additives, preservatives, and unhealthy
                additives that are often found in processed foods and restaurant
                meals. This gives you the ability to make healthier choices,
                control portion sizes, and cater to specific dietary needs.
              </p>
            </div>
          </div>
          <div className="productContainer1">
            <div className="mobViewdiv"></div>
            <div className="Advantages">
              <h1>Portion Control</h1>
              <p>
                One of the challenges with eating out is the tendency for larger
                portion sizes, which can contribute to overeating. Cooking at
                home allows you to control portion sizes and be mindful of your
                calorie intake. This can be particularly beneficial for weight
                management and maintaining a balanced diet.
              </p>
            </div>
          </div>
          <div className="productContainer1">
            <div className="mobViewdiv"></div>
            <div className="Advantages">
              <h1> Creativity and Variety</h1>
              <p>
                Cooking at home allows you to explore a wide range of recipes,
                experiment with flavors, and get creative in the kitchen. You
                have the freedom to try new ingredients, cooking techniques, and
                cultural cuisines, which can make mealtime more exciting and
                enjoyable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
